import { render, staticRenderFns } from "./accessOptions.vue?vue&type=template&id=ab2e9fd4&"
import script from "./accessOptions.vue?vue&type=script&lang=ts&"
export * from "./accessOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports